import Vue from "vue";
import Vuex from "vuex";
import firebase from "firebase";
import axios from "axios";

Vue.use(Vuex);

export default {
  namespaced: true,
  state: {
    listTools: [],
    listConnections: [],
    listGuides: [],
    guideChat: {
      messages: []
    },
    guideChatId: null,
    blogs: [],
    listBloggers: [],
    tracks: [],
    publishings: [],
    sessions: [],
    products: [],
    tools: [],
    connections: [],
    bloggerBlogs: []
  },
  getters: {
    listPublishings(state) {
      return state.publishings;
    },
    listSessionss(state) {
      return state.sessions;
    },
    listTools(state) {
      return state.listTools;
    },
    listConnections(state) {
      return state.listConnections;
    },
    listGuides(state) {
      return state.listGuides;
    },
    guideChat(state) {
      return state.guideChat;
    },
    blogs(state) {
      return state.blogs;
    },
    listBloggers(state) {
      return state.listBloggers;
    },
    tracks(state) {
      return state.tracks;
    },
    products(state) {
      return state.products;
    },
    tools(state) {
      return state.tools;
    },
    connections(state) {
      return state.connections;
    },
    bloggerBlogs(state) {
      return state.bloggerBlogs;
    }
  },
  actions: {
    recordFeedback(
      { commit },
      { userId, pathId, entityId, sessionId, feedbackType, meta = null }
    ) {
      console.log(
        `New RECORD FEEDBACK FBType:${feedbackType} user:${userId} pathId:${pathId} entityId: ${entityId} sessionId: ${sessionId} meta: ${meta} `
      );

      return new Promise((res, rej) => {
        const db = firebase.firestore();

        let entityRef = entityId
          ? db.collection(`listings/${pathId}/items`).doc(entityId)
          : db.collection(`listings`).doc(pathId);

        axios.get("https://api.ipify.org?format=json").then(res => {
          const ipAddress = res.data.ip;
          console.log(ipAddress);

          return entityRef.get().then(doc => {
            let data = { ...doc.data() };
            const tracking = userId
              ? {
                  _created_at: new Date(),
                  user: userId,
                  sessionId: sessionId,
                  ip: ipAddress
                }
              : {
                  _created_at: new Date(),
                  sessionId: sessionId,
                  ip: ipAddress
                };

            if (meta) tracking.meta = meta;

            if (data.feedback) {
              if (data.feedback[feedbackType]) {
                if (data.feedback && data.feedback.views) {
                  data.feedback[feedbackType].push(tracking);
                }
              } else {
                data.feedback[feedbackType] = [tracking];
              }
            } else {
              console.log(`Create Feedback for ${tracking}`);
              data = {
                ...doc.data(),
                feedback: {
                  views: [tracking]
                }
              };
            }
            data._updated_at = new Date();
            return entityRef
              .set({
                ...data
              })
              .then(function() {
                console.log("Document Recording successfully updated!");
                //res(true);
              })
              .catch(function(error) {
                console.error("Error updating document: ", error);
                //rej(error);
              });
          });
        });
      });
    },
    /* TOOLS */
    getListTools({ commit, state }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let companiesRef = db.collection("companies");
        let tools = [];
        companiesRef.onSnapshot(querySnapshot => {
          return querySnapshot.forEach(doc => {
            return (
              db
                .collection(`${doc.ref.path}/tools`)
                //.where("_is_active", "==", true)
                .where("status", "==", "active")
                .onSnapshot(snapshot => {
                  snapshot.forEach(doc => {
                    tools.push({
                      ...doc.data(),
                      toolId: doc.id,
                      toolRef: doc.ref
                    });
                  });
                })
            );
          });
        });
        commit("SET_LIST_TOOLS", tools);
        res(tools);
      });
    },
    getToolById({ commit }, toolId) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let listingsGuidesRef = db.collection("listings/tools/items");
        let tool = {};
        listingsGuidesRef
          .where("is_active", "==", true)
          .get()
          .then(function(querySnapshot) {
            querySnapshot.forEach(function(doc) {
              if (doc.id == toolId) {
                tool = doc.data();
              }
            });
            res(tool);
          })
          .catch(function(error) {
            rej(error);
            console.log("Error getting documents: ", error);
          });
      });
    },
    getToolByName({ commit }, toolName) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let listingsToolsRef = db.collection("listings/tools/items");
        let tool = {};
        listingsToolsRef
          // .where("status", "==", "active")
          .get()
          .then(function(querySnapshot) {
            querySnapshot.forEach(function(doc) {
              if (doc.data().name == toolName) {
                tool = doc.data();
              }
            });
            res(tool);
          })
          .catch(function(error) {
            rej(error);
            console.log("Error getting documents: ", error);
          });
      });
    },

    /*CONNECTIONS*/
    getListConnections({ commit, state }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let connectionsRef = db.collection("listings/connections/items");
        let connections = [];
        connectionsRef
          //.where("_is_active", "==", true)

          .where("status", "==", "active")
          .get()
          .then(snap => {
            snap.forEach(doc => {
              connections.push({
                ...doc.data(),
                connectionId: doc.id,
                connectionRef: doc.ref
              });
            });
            commit("SET_LIST_CONNECTIONS", connections);
            res(connections);
          });
        // return db
        //   .collection(`${doc.ref.path}/tools`)
        //   .where("_is_active", "==", true)
        //   .onSnapshot(snapshot => {
        //     snapshot.forEach(doc => {
        //       connections.push({
        //         ...doc.data(),
        //         toolId: doc.id,
        //         toolRef: doc.ref
        //       });
        //     });
        //   });
        // res(tools);
      });
    },
    getConnectionByName({ commit }, connectionName) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let listingsConnectionsRef = db.collection(
          "listings/connections/items"
        );
        let connection = {};
        listingsConnectionsRef
          // .where("status", "==", "active")
          .get()
          .then(function(querySnapshot) {
            querySnapshot.forEach(function(doc) {
              if (doc.data().name == connectionName) {
                connection = doc.data();
              }
            });
            res(connection);
          })
          .catch(function(error) {
            rej(error);
            console.log("Error getting documents: ", error);
          });
      });
    },

    /* PRESENTATION */
    getPresentationBySlug({ commit }, slug) {
      debugger;
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const listingsPresentationsRef = db.collection(
          "listings/presentations/items"
        );
        let presentation = {};
        listingsPresentationsRef
          .where("status", "==", "active")
          .where("slug", "==", slug)
          .get()
          .then(querySnapshot => {
            if (querySnapshot.docs.length > 0) {
              const doc = querySnapshot.docs[0];
              presentation = doc.data();
              presentation.id = doc.id;
              res(presentation);
            } else {
              res({});
            }
          })
          .catch(function(error) {
            rej(error);
            console.log("Error getting  Presentationdocuments: ", error);
          });
      });
    },
    getFormBySlug({ commit }, slug) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const listingsFormsRef = db.collection("listings/forms/items");
        let form = {};
        listingsFormsRef
          .where("status", "==", "active")
          .where("slug", "==", slug)
          .get()
          .then(querySnapshot => {
            if (querySnapshot.docs.length > 0) {
              const doc = querySnapshot.docs[0];
              form = doc.data();
              form.id = doc.id;
              res(form);
            } else {
              res({});
            }
          })
          .catch(function(error) {
            rej(error);
            console.log("Error getting Form Doc: ", error);
          });
      });
    },
    viewPresentation({ commit }, { userId, presentationId, sessionId }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let presentRef = db
          .collection("listings/present/items")
          .doc(presentationId);

        return presentRef.get().then(doc => {
          let data = { ...doc.data() };
          let view = userId
            ? {
                _created_at: new Date(),
                user: userId
              }
            : {
                _created_at: new Date(),
                sessionId: sessionId
              };

          if (data.feedback) {
            if (data.feedback.views) {
              if (data.feedback && data.feedback.views) {
                data.feedback.views.push(view);
              }
            } else {
              data.feedback.views = [view];
            }
          } else {
            data = {
              ...doc.data(),
              feedback: {
                views: [view]
              }
            };
          }
          data._updated_at = new Date();
          return presentRef
            .set({
              ...data
            })
            .then(function() {
              console.log("Document successfully updated!");
              res(true);
            })
            .catch(function(error) {
              console.error("Error updating document: ", error);
              rej(error);
            });
        });
      });
    },

    /* GUIDES */
    getListGuides({ commit, state }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let listingsGuidesRef = db.collection("listings/guides/items");
        let guides = [];
        listingsGuidesRef
          .where("status", "==", "active") //@TODO _ Should I pull all or pass status
          .get()
          .then(function(querySnapshot) {
            querySnapshot.forEach(function(doc) {
              // doc.data() is never undefined for query doc snapshots
              guides.push(doc.data());
            });
          })
          .catch(function(error) {
            console.log("Error getting documents: ", error);
          });
        commit("SET_LIST_GUIDES", guides);
        res(guides);
      });
    },
    getGuideById({ commit, state }, profile) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let guide = null;
        let listingGuideRef = db
          .collection("listings/guides/items")
          .doc(profile.userId);
        listingGuideRef
          .get()
          .then(function(doc) {
            if (doc.exists) {
              guide = doc.data();
            } else {
              // doc.data() will be undefined in this case
              console.log("No such document!");
            }
            res(guide);
          })
          .catch(function(error) {
            console.log("Error getting document:", error);
            rej(error);
          });
      });
    },
    getGuideByProfileName({ commit, state }, profileName) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const guideRef = db.collection("listings/guides/items");

        return guideRef
          .where("profile.profileName", "==", profileName)
          .get()
          .then(snap => {
            if (snap.docs.length > 0) {
              res({ ...snap.docs[0].data(), userId: snap.docs[0].id });
            } else {
              res(null);
            }
          })
          .catch(err => {
            console.log("error in getting guide data: ", err);
            rej(err);
          });
      });
    },
    guideApply({ commit, state }, userId) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let listingGuideRef = db
          .collection("listings/guides/items")
          .doc(userId);

        // Set the "capital" field of the city 'DC'
        return listingGuideRef
          .set({
            _created_at: new Date(),
            status: "created"
          })
          .then(function() {
            console.log("User Successfully Applied!");
            res(true);
          })
          .catch(function(error) {
            // The document probably doesn't exist.
            console.error("Error updating document: ", error);
            rej(error);
          });
      });
    },
    guideRequestProfileUpdate({ commit, state }, profile) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let listingGuideRef = db
          .collection("listings/guides/items")
          .doc(profile.userId);
        let guide_profile = profile._dashboards.guide;

        // Set the "capital" field of the city 'DC'
        return listingGuideRef
          .update({
            _updated_at: new Date(),
            profile_update: guide_profile //The user information- profile data is what is saved in guide
          })
          .then(function() {
            console.log("User Successfully Requested for Updated Profile!");
            res(true);
          })
          .catch(function(error) {
            // The document probably doesn't exist.
            console.error("Error updating document: ", error);
            rej(error);
          });
      });
    },
    getListGuideSessions({ commit, state }, uid) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let _guideSessionsRef = db
          .collection("users")
          .doc(uid)
          .collection("lists")
          .doc("__guide_sessions");

        _guideSessionsRef
          .get()
          .then(function(doc) {
            // querySnapshot.forEach((doc) => {
            if (
              doc.exists &&
              doc.data().sessions &&
              doc.data().sessions.length
            ) {
              res(doc.data().sessions);
            } else {
              res(true);
            }
          })
          .catch(function(error) {
            console.error("Error get guide sessions: ", error);
            rej(error);
          });
      });
    },
    createSession({ commit }, session) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const sessionsRef = db.collection("sessions");
        const guideSessionsRef = db.doc(
          `users/${session.guide.user_id}/lists/__guide_sessions`
        );
        const createdAt = new Date();
        session.guide.user_id = db.doc(`users/${session.guide.user_id}`);
        let newSessionDoc = sessionsRef.doc();

        return newSessionDoc
          .set({
            ...session,
            _created_at: createdAt
          })
          .then(() => {
            res(true);
            let guideSession = {
              _created_at: createdAt,
              _booked_at: session._booked_at,
              user: { ...session.user },
              session: db.doc(`sessions/${newSessionDoc.id}`),
              plan: session.plan,
              room_id: session.room_id
            };
            guideSessionsRef
              .get()
              .then(doc => {
                if (doc.exists) {
                  return guideSessionsRef.update({
                    sessions: [...doc.data().sessions, guideSession],
                    _updated_at: new Date()
                  });
                } else {
                  return guideSessionsRef.set({
                    _created_at: createdAt,
                    sessions: [guideSession]
                  });
                }
              })
              .catch(err => {
                console.log("error in saving list guide sessions:", err);
              });
          })
          .catch(err => {
            console.log("error in creating new session:", err);
            rej(err);
          });
      });
    },
    adminGuideApproveApplication(
      { commit, state },
      { admin: profile, guideUserId: userId }
    ) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let listingGuideRef = db
          .collection("listings/guides/items")
          .doc(userId);
        return listingGuideRef
          .update({
            _approved_at: new Date(),
            _approved_by: `users/${profile.userId}`,
            status: "approved"
          })
          .then(function() {
            console.log("User Successfully Approved!");
            res(true);
            //Now Complete SetUp of Approval
            // let send = firebase
            //   .functions()
            //   .httpsCallable("guideAppApprovalSetUp");
            // send({ guideUserId: userId })
            //   .then(data => {
            //     console.log("successfully sent email and setup data", res);
            //   })
            //   .catch(function(error) {
            //     console.error("Error setting up guide: ", error);
            //     rej(error);
            //   });
          })
          .catch(function(error) {
            // The document probably doesn't exist.
            console.error("Error updating document: ", error);
            rej(error);
          });
      });
    },
    adminGuideApproveUpdate(
      { commit, state },
      { admin: profile, guide: guide_profile }
    ) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let listingGuideRef = db
          .collection("listings/guides/items")
          .doc(guide_profile.user.userId);
        return listingGuideRef
          .update({
            _update_approved_at: new Date(),
            _update_approved_by: `users/${profile.userId}`,
            profile: guide_profile.profile_update,
            profile_update: null
          })
          .then(function() {
            console.log("User Successfully Updated!");
            res(true);
          })
          .catch(function(error) {
            // The document probably doesn't exist.
            console.error("Error updating document: ", error);
            rej(error);
          });
      });
    },
    adminGuideApproveListing(
      { commit, state },
      { admin: profile, guideUserId: userId }
    ) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let listingGuideRef = db
          .collection("listings/guides/items")
          .doc(userId);
        return listingGuideRef
          .update({
            _listing_at: new Date(),
            _listed_by: `users/${profile.userId}`,
            status: "active" //Create a Guides section for user
          })
          .then(function() {
            console.log("User Successfully Listed!");
            res(true);
          })
          .catch(function(error) {
            // The document probably doesn't exist.
            console.error("Error updating document: ", error);
            rej(error);
          });
      });
    },
    activateGuide({ commit, state }, profile) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let listingGuideRef = db
          .collection("listings/guides/items")
          .doc(profile.userId);
        let guide_profile = profile._dashboards.guide;

        // Set the "capital" field of the city 'DC'
        return listingGuideRef
          .update({
            _updated_at: new Date(),
            profile: guide_profile,
            user: {
              email: profile.email,
              userId: profile.userId,
              firstname: profile.firstname || "",
              imgURL: profile.imgURL || "",
              lastname: profile.lastname || "",
              phoneNumber: profile.phoneNumber || ""
            }
          })
          .then(function() {
            console.log("Guide Info Successfully updated!");
            res(true);
          })
          .catch(function(error) {
            // The document probably doesn't exist.
            console.error("Error updating Guide Info: ", error);
            rej(error);
          });
      });
    },
    updateGuideInfo({ dispatch, commit, state }, profile) {
      const self = this;
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let listingGuideRef = db
          .collection("listings/guides/items")
          .doc(profile.userId);
        let data = {};
        let guide_profile = profile._dashboards.guide;
        listingGuideRef
          .get()
          .then(function(doc) {
            if (doc.data().status == "created") {
              data = {
                status: "active",
                _updated_at: new Date(),
                profile: guide_profile
              };
            } else {
              data = {
                _updated_at: new Date(),
                profile: guide_profile
              };
            }
            return listingGuideRef
              .update(data)
              .then(function() {
                dispatch("getCompleteGuideAvailability", profile.userId).then(
                  res => {
                    console.log("getCompleteGuideAvailability => ", res);
                    const timesRef = db.doc(
                      `listings/guides/items/${profile.userId}/guide_info/__guide_availability`
                    );
                    return timesRef
                      .get()
                      .then(doc => {
                        return timesRef.set(res).then(() => {
                          console.log("successfully saved time");
                          // res(true);
                        });
                      })
                      .catch(err => {
                        console.log("error in updating times: ", err);
                        // rej(err);
                      });
                  }
                );
                console.log("Guide Info Successfully updated!");
                res(true);
              })
              .catch(function(error) {
                // The document probably doesn't exist.
                console.error("Error updating Guide Info: ", error);
                rej(error);
              });
          })
          .catch(function(error) {
            console.log("Error getting document:", error);
            rej(error);
          });
      });
    },
    getGuideAvailability({ commit, state }, guideId) {
      return new Promise((res, rej) => {
        let db = firebase.firestore();
        const timesRef = db
          .collection(`users`)
          .doc(`${guideId}/lists/__guide_availability`);
        return timesRef
          .get()
          .then(doc => {
            //console.log("inside pip pip");
            if (doc.exists) {
              let times = doc.data();
              res(times);
            } else {
              res([]);
            }
          })
          .catch(err => {
            console.log("Error in getting available times: ", err);
            rej(err);
          });
      });
    },
    getCompleteGuideAvailability({ commit, state }, guideId) {
      return new Promise((res, rej) => {
        let db = firebase.firestore();
        const timesRef = db
          .collection(`users`)
          .doc(`${guideId}/lists/__guide_availability`);
        return timesRef
          .get()
          .then(doc => {
            if (doc.exists) {
              let times = doc.data();
              res(times);
            } else {
              res([]);
            }
          })
          .catch(err => {
            console.log("Error in getting available times: ", err);
            rej(err);
          });
      });
    },
    getSlots({ commit, state }, guideId) {
      return new Promise((res, rej) => {
        let db = firebase.firestore();
        const slotRef = db.doc(`users/${guideId}/lists/__guide_availability`);
        return slotRef
          .get()
          .then(doc => {
            if (doc.exists) {
              // return [...doc.data()];
              // console.log("tag3", doc.data());
              let slots = doc.data();
              res(slots);
            } else {
              res([]);
            }
          })
          .catch(err => {
            console.log("Error in getting available times: ", err);
            rej(err);
          });
      });
    },
    updateGuideAvailability({ commit, state }, { id, mode, time, guideId }) {
      return new Promise((res, rej) => {
        let db = firebase.firestore();
        const timesRef = db
          .collection(`users`)
          .doc(`${guideId}/lists/__guide_availability`);
        return timesRef
          .get()
          .then(doc => {
            if (doc.exists) {
              let times = [...doc.data().timings];
              if (mode == "updated") {
                let timeToUpdate = {};
                times.forEach(aTime => {
                  if (aTime.id == id) {
                    timeToUpdate = aTime;
                  }
                });
                let updatedTimes = times.filter(aTime => aTime.id !== id);
                timesRef
                  .update({
                    timings: firebase.firestore.FieldValue.arrayRemove(
                      timeToUpdate
                    )
                  })
                  .then(() => {
                    console.log("in this on while adding", updatedTimes);
                    return timesRef
                      .update({
                        timings: [...updatedTimes, { ...time }]
                      })
                      .then(() => {
                        console.log("successfully updated time");
                        res(true);
                      });
                  });
              } else if (mode == "deleted") {
                let timeToDelete = {};
                times.forEach(aTime => {
                  if (aTime.id == id) {
                    timeToDelete = aTime;
                  }
                });
                return timesRef
                  .update({
                    timings: firebase.firestore.FieldValue.arrayRemove(
                      timeToDelete
                    )
                  })
                  .then(() => {
                    console.log("successfully updated time");
                    res(true);
                  });
              } else if (mode == "inserted") {
                console.log("while insered", times, time);
                return timesRef
                  .update({
                    timings: [...times, { ...time }]
                  })
                  .then(() => {
                    console.log("successfully saved time");
                    res(true);
                  });
              }
            } else {
              return timesRef
                .set({
                  _created_at: new Date(),
                  timings: [{ ...time }]
                })
                .then(() => {
                  console.log("successfully saved time");
                  res(true);
                });
            }
          })
          .catch(err => {
            console.log("error in updating times: ", err);
            rej(err);
          });
      });
    },
    updateSlot({ commit, state }, payload) {
      console.log("in update slot 1", payload.activeDay);
      let slot = {
        end: payload.end,
        start: payload.start,
        _create_at: new Date()
      };
      return new Promise((res, rej) => {
        let db = firebase.firestore();
        const timesRef = db
          .collection(`users`)
          .doc(`${payload.guideId}/lists/__guide_availability`);
        console.log("in update slot 2", timesRef);
        return timesRef.get().then(doc => {
          if (doc.exists) {
            console.log("slotscc", payload.activeDay);
            let slots = doc.data();

            console.log("slots", slots);
            return timesRef
              .update({
                [payload.activeDay]: firebase.firestore.FieldValue.arrayUnion({
                  ...slot
                })
              })
              .then(() => {
                console.log("successfully saved time");
                res(true);
              });
          }
        });
        // .catch(err => {
        //   console.log("error in updating times: ", err);
        //   rej(err);
        // });
      });
    },
    checkGuideProfileName({ commit, state }, profileName) {
      let userName = profileName.trim().toLowerCase();
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let guides = db
          .collection("listings")
          .doc("guides")
          .collection("items")
          .where("profile.profileName", "==", userName);
        return guides
          .get()
          .then(querySnapshot => {
            if (querySnapshot.docs.length > 0) {
              res("already taken");
            } else {
              res("accepted");
            }
          })
          .catch(error => {
            console.log(error);
            rej(error);
          });
      });
    },
    getGuideChatOld({ commit, state }, { guideId, identity, sessionId }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const chatRef = db.collection(
          `listings/guides/items/${guideId}/guide_info/__guide_messages/messages`
        );
        return chatRef
          .where("sessionId", "==", sessionId)
          .get()
          .onSnapshot(snap => {
            if (snap.docs.length > 0) {
              commit("SET_GUIDE_CHAT", snap.docs[0].data());
              commit("SET_GUIDE_CHAT_ID", snap.docs[0].id);
              res(snap.docs[0].data());
            } else {
              let chatDoc = chatRef.doc();
              chatDoc
                .set({
                  _created_at: new Date(),
                  identity: identity,
                  sessionId: sessionId,
                  messages: []
                })
                .then(doc => {
                  chatDoc.onSnapshot(doc => {
                    commit("SET_GUIDE_CHAT", doc.data());
                    commit("SET_GUIDE_CHAT_ID", doc.id);
                    res(doc.data());
                  });
                });
            }
          })
          .catch(err => {
            console.log("error in getting guide messages:", err);
          });
      });
    },
    getGuideChat({ commit, state }, { guideId, identity, sessionId }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const chatRef = db.doc(
          `listings/guides/items/${guideId}/guide_info/__guide_messages/messages/${sessionId}`
        );

        chatRef
          .get()
          .then(doc => {
            if (doc.exists) {
              chatRef.onSnapshot(doc => {
                commit("SET_GUIDE_CHAT", doc.data());
                commit("SET_GUIDE_CHAT_ID", doc.id);
                res(doc.data());
              });
            } else {
              chatRef
                .set({
                  _created_at: new Date(),
                  identity: identity,
                  messages: []
                })
                .then(doc => {
                  chatRef.onSnapshot(doc => {
                    commit("SET_GUIDE_CHAT", doc.data());
                    commit("SET_GUIDE_CHAT_ID", doc.id);
                    res(doc.data());
                  });
                });
            }
          })
          .catch(err => {
            console.log("error in saving list guide sessions 3:", err);
          });
      });
    },
    addGuideMsg({ commit, state }, { guideId, message }) {
      const db = firebase.firestore();
      let chatRef = db.doc(
        `listings/guides/items/${guideId}/guide_info/__guide_messages/messages/${state.guideChatId}`
      );

      chatRef
        .update({
          messages: firebase.firestore.FieldValue.arrayUnion(message)
        })
        .then(function(data) {
          console.log("Data has been logged");
        })
        .catch(function(error) {
          console.error("Error adding guide message: ", error);
        });
    },
    /* BLOGGER */
    getBloggerById({ commit, state }, profile) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let guide = null;
        let listingGuideRef = db
          .collection("listings/bloggers/items")
          .doc(profile.userId);
        listingGuideRef
          .get()
          .then(function(doc) {
            if (doc.exists) {
              guide = doc.data();
            } else {
              // doc.data() will be undefined in this case
              console.log("No such document!");
            }
            res(guide);
          })
          .catch(function(error) {
            console.log("Error getting document:", error);
            rej(error);
          });
      });
    },
    bloggerApply({ commit, state }, userId) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let listingGuideRef = db
          .collection("listings/bloggers/items")
          .doc(userId);

        // Set the "capital" field of the city 'DC'
        return listingGuideRef
          .set({
            _created_at: new Date(),
            status: "created"
          })
          .then(function() {
            console.log("User Successfully Applied!");
            res(true);
          })
          .catch(function(error) {
            // The document probably doesn't exist.
            console.error("Error updating document: ", error);
            rej(error);
          });
      });
    },
    checkBloggerProfileName({ commit, state }, profileName) {
      let userName = profileName.trim().toLowerCase();
      return new Promise((res, rej) => {
        let nameExists = false;
        const db = firebase.firestore();
        let guides = db
          .collection("listings")
          .doc("bloggers")
          .collection("items")
          .where("profile.profileName", "==", userName);
        return guides
          .get()
          .then(querySnapshot => {
            if (querySnapshot.docs.length > 0) {
              res("already taken");
            } else {
              res("accepted");
            }
          })
          .catch(error => {
            console.log(error);
            rej(error);
          });
      });
    },
    activateBlogger({ commit, state }, profile) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let listingBlogRef = db
          .collection("listings/bloggers/items")
          .doc(profile.userId);
        let blogger_profile = profile._dashboards.blogger;

        // Set the "capital" field of the city 'DC'
        return listingBlogRef
          .update({
            _updated_at: new Date(),
            profile: blogger_profile,
            user: {
              email: profile.email,
              userId: profile.userId,
              firstname: profile.firstname || "",
              imgURL: profile.imgURL || "",
              lastname: profile.lastname || "",
              phoneNumber: profile.phoneNumber || ""
            }
          })
          .then(function() {
            console.log("Blogger Info Successfully updated!");
            res(true);
          })
          .catch(function(error) {
            // The document probably doesn't exist.
            console.error("Error updating Guide Info: ", error);
            rej(error);
          });
      });
    },
    updateBloggerInfo({ commit, state }, profile) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let listingBlogRef = db
          .collection("listings/bloggers/items")
          .doc(profile.userId);
        let data = {};
        let blogger_profile = profile._dashboards.blogger;
        listingBlogRef
          .get()
          .then(function(doc) {
            if (doc.data().status == "created") {
              data = {
                status: "active",
                _updated_at: new Date(),
                profile: blogger_profile
              };
            } else {
              data = {
                _updated_at: new Date(),
                profile: blogger_profile
              };
            }
            return listingBlogRef
              .update(data)
              .then(function() {
                console.log("Blogger Info Successfully updated!");
                res(true);
              })
              .catch(function(error) {
                // The document probably doesn't exist.
                console.error("Error updating Blogger Info: ", error);
                rej(error);
              });
          })
          .catch(function(error) {
            console.log("Error getting document:", error);
            rej(error);
          });
      });
    },
    getListBloggers({ commit }) {
      return new Promise(res => {
        const db = firebase.firestore();
        let listingsBloggersRef = db.collection("listings/bloggers/items");
        let bloggers = [];

        listingsBloggersRef
          .where("status", "==", "active")
          .get()
          .then(function(querySnapshot) {
            querySnapshot.forEach(function(doc) {
              // doc.data() is never undefined for query doc snapshots
              bloggers.push(doc.data());
            });
          })
          .catch(function(error) {
            console.log("Error getting documents: ", error);
          });
        commit("SET_LIST_BLOGGERS", bloggers);
        res(bloggers);
      });
    },
    getBloggerByProfileName({ commit }, bloggerName) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let listingsGuidesRef = db.collection("listings/bloggers/items");
        let guide = {};
        listingsGuidesRef
          .where("status", "==", "active")
          .get()
          .then(function(querySnapshot) {
            querySnapshot.forEach(function(doc) {
              if (
                doc.data().profile &&
                doc.data().profile.profileName == bloggerName
              ) {
                guide = doc.data();
                guide.id = doc.id;
              }
            });
            res(guide);
          })
          .catch(function(error) {
            rej(error);
            console.log("Error getting documents: ", error);
          });
      });
    },

    /*BLOG-ARTICLE*/
    submitBloggerArticle({ commit, state }, { article, blogger }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let listingBlogRef = db
          .collection("listings/blogs/items")
          .doc(article.id);
        return listingBlogRef
          .set({
            _submitted_at: new Date(),
            id: article.id,
            docURL: article.docURL,
            status: "submitted",
            doc: { ...article },
            blogger: blogger
          })
          .then(function() {
            console.log("Blog Article Successfully submitted!");
            res(true);
          })
          .catch(function(error) {
            console.error("Error submitting Blogger's Article", error);
            rej(error);
          });
      });
    },
    getListArticle({ commit, state }, id) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let listingsBlogRef = db.doc(`listings/blogs/items/${id}`);
        return listingsBlogRef
          .get()
          .then(doc => {
            res(doc.data());
          })
          .catch(function(error) {
            console.log("Error getting document: ", error);
            rej(error);
          });
      });
    } /* TODO: Merge to getListBlogs */,
    getListBlogs({ commit }, contentType = "article") {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let listingsBlogsRef = db.collection("listings/blogs/items");
        let blogs = [];

        listingsBlogsRef
          .where("status", "==", "active")
          .where("doc.content_type", "==", contentType)
          .get()
          .then(function(querySnapshot) {
            querySnapshot.forEach(function(doc) {
              // doc.data() is never undefined for query doc snapshots
              blogs.push(doc.data());
            });
            commit("SET_LIST_BLOGS", blogs);
            res(blogs);
          })
          .catch(function(error) {
            rej(error);
            console.log("Error getting documents: ", error);
          });
      });
    },
    getBlogsByBloggerId({ commit }, bloggerId) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let listingsBlogsRef = db.collection("listings/blogs/items");
        let blogs = [];

        listingsBlogsRef
          .where("status", "==", "active")
          .where("blogger.bloggerId", "==", bloggerId)
          .get()
          .then(function(querySnapshot) {
            querySnapshot.forEach(function(doc) {
              // doc.data() is never undefined for query doc snapshots
              blogs.push(doc.data());
            });
            commit("SET_LIST_BLOGS", blogs);
            res(blogs);
          })
          .catch(function(error) {
            rej(error);
            console.log("Error getting documents: ", error);
          });
      });
    },
    getBlogByTitle({ commit }, blogTitle) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let listingsBlogRef = db.collection("listings/blogs/items");
        let blog = {};
        listingsBlogRef
          .get()
          .then(function(querySnapshot) {
            querySnapshot.forEach(function(doc) {
              if (doc.data().slug == blogTitle) {
                blog = doc.data();
              }
            });
            res(blog);
          })
          .catch(function(error) {
            rej(error);
            console.log("Error getting document: ", error);
          });
      });
    },
    getBlogById({ commit }, blogId) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let listingsBlogRef = db.collection("listings/blogs/items");
        let blog = {};
        listingsBlogRef
          .where("id", "==", blogId)
          .get()
          .then(function(querySnapshot) {
            blog = querySnapshot.docs[0].data();
            res(blog);
          })
          .catch(function(error) {
            rej(error);
            console.log("Error getting document: ", error);
          });
      });
    },
    addClap({ commit }, { userId, blogId }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let blogRef = db.collection("listings/blogs/items").doc(blogId);

        return blogRef.get().then(doc => {
          let data = { ...doc.data() };

          if (data.feedback) {
            if (data.feedback.thankyous) {
              data.feedback.thankyous.push({
                _created_at: new Date(),
                userId: userId
              });
            } else {
              data.feedback.thankyous = [
                {
                  _created_at: new Date(),
                  userId: userId
                }
              ];
            }
          } else {
            data = {
              ...doc.data(),
              feedback: {
                thankyous: [
                  {
                    _created_at: new Date(),
                    userId: userId
                  }
                ]
              }
            };
          }
          data._updated_at = new Date();
          return blogRef
            .set({
              ...data
            })
            .then(function() {
              console.log("Document successfully updated!");
              res(true);
            })
            .catch(function(error) {
              console.error("Error updating document: ", error);
              rej(error);
            });
        });
      });
    },
    postFeedback({ commit }, { blogId, feedback }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let blogRef = db.collection("listings/blogs/items").doc(blogId);

        return blogRef.get().then(doc => {
          let data = { ...doc.data() };
          feedback._created_at = new Date();
          if (data.feedback) {
            if (data.feedback.feedback) {
              data.feedback.feedback.push(feedback);
            } else {
              data.feedback.feedback = [feedback];
            }
          } else {
            data = {
              ...doc.data(),
              feedback: {
                feedback: [feedback]
              }
            };
          }
          data._updated_at = new Date();
          return blogRef
            .set({
              ...data
            })
            .then(function() {
              console.log("Document successfully updated!");
              res(true);
            })
            .catch(function(error) {
              console.error("Error updating document: ", error);
              rej(error);
            });
        });
      });
    },
    postTrackFeedback({ commit }, { trackId, feedback }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let trackRef = db
          .collection("listings/tracks_guide/items")
          .doc(trackId);

        return trackRef.get().then(doc => {
          let data = { ...doc.data() };
          feedback._created_at = new Date();
          if (data.feedback) {
            if (data.feedback.feedback) {
              data.feedback.feedback.push(feedback);
            } else {
              data.feedback.feedback = [feedback];
            }
          } else {
            data = {
              ...doc.data(),
              feedback: {
                feedback: [feedback]
              }
            };
          }
          data._updated_at = new Date();
          return trackRef
            .set({
              ...data
            })
            .then(function() {
              console.log("Document successfully updated!");
              res(true);
            })
            .catch(function(error) {
              console.error("Error updating document: ", error);
              rej(error);
            });
        });
      });
    },
    clapFeedback({ commit }, { userId, blogId, feedbackId }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let blogRef = db.collection("listings/blogs/items").doc(blogId);

        return blogRef.get().then(doc => {
          let data = { ...doc.data() };
          data.feedback.feedback.forEach(el => {
            if (el.id == feedbackId) {
              el.thankyous.push({
                _created_at: new Date(),
                userId: userId
              });
            }
          });
          data._updated_at = new Date();
          return blogRef
            .set({
              ...data
            })
            .then(function() {
              console.log("Document successfully updated!");
              res(true);
            })
            .catch(function(error) {
              console.error("Error updating document: ", error);
              rej(error);
            });
        });
      });
    },
    claptrackFeedback({ commit }, { userId, trackId, feedbackId }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let trackRef = db
          .collection("listings/tracks_guide/items")
          .doc(trackId);

        return trackRef.get().then(doc => {
          let data = { ...doc.data() };
          data.feedback.feedback.forEach(el => {
            if (el.id == feedbackId) {
              el.thankyous.push({
                _created_at: new Date(),
                userId: userId
              });
            }
          });
          data._updated_at = new Date();
          return trackRef
            .set({
              ...data
            })
            .then(function() {
              console.log("Document successfully updated!");
              res(true);
            })
            .catch(function(error) {
              console.error("Error updating document: ", error);
              rej(error);
            });
        });
      });
    },
    addBookMarkBlog({ commit }, { userId, blogId }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let blogRef = db.collection("listings/blogs/items").doc(blogId);

        return blogRef.get().then(doc => {
          let data = { ...doc.data() };
          let bookmark = {
            _created_at: new Date(),
            user: userId
          };

          if (data.feedback) {
            if (data.feedback.bookmarks) {
              if (data.feedback && data.feedback.bookmarks) {
                if (
                  data.feedback.bookmarks.filter(aBookMark => {
                    aBookMark.user == userId;
                  })
                ) {
                  data.feedback.bookmarks.forEach(aBookmark => {
                    if (aBookmark.user == userId) {
                      aBookmark._deleted_at = null;
                      return;
                    }
                  });
                } else {
                  data.feedback.bookmarks.push(bookmark);
                }
              }
            } else {
              data.feedback.bookmarks = [bookmark];
            }
          } else {
            data = {
              ...doc.data(),
              feedback: {
                bookmarks: [bookmark]
              }
            };
          }
          data._updated_at = new Date();
          return blogRef
            .set({
              ...data
            })
            .then(function() {
              console.log("Document successfully updated!");
              res(true);
            })
            .catch(function(error) {
              console.error("Error updating document: ", error);
              rej(error);
            });
        });
      });
    },
    removeBookMarkBlog({ commit }, { userId, blogId }) {
      return new Promise((res, rej) => {
        //debugger
        const db = firebase.firestore();
        let blogRef = db.collection("listings/blogs/items").doc(blogId);

        return blogRef.get().then(doc => {
          if (doc.exists) {
            let data = { ...doc.data() };
            data._updated_at = new Date();

            //Soft delete the bookmark for this user
            if (data.feedback && data.feedback.bookmarks) {
              data.feedback.bookmarks.forEach(aBookmark => {
                if (aBookmark.user == userId) {
                  aBookmark._deleted_at = new Date();
                }
              });
            }

            return blogRef
              .set({
                ...data
              })
              .then(function() {
                console.log("Document successfully updated!");
                res(true);
              })
              .catch(function(error) {
                console.error("Error updating document: ", error);
                rej(error);
              });
          }
        });
      });
    },
    viewBlog({ commit }, { userId, blogId, sessionId }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let blogRef = db.collection("listings/blogs/items").doc(blogId);

        return blogRef.get().then(doc => {
          let data = { ...doc.data() };
          let view = userId
            ? {
                _created_at: new Date(),
                user: userId
              }
            : {
                _created_at: new Date(),
                sessionId: sessionId
              };

          if (data.feedback) {
            if (data.feedback.views) {
              if (data.feedback && data.feedback.views) {
                data.feedback.views.push(view);
              }
            } else {
              data.feedback.views = [view];
            }
          } else {
            data = {
              ...doc.data(),
              feedback: {
                views: [view]
              }
            };
          }
          data._updated_at = new Date();
          return blogRef
            .set({
              ...data
            })
            .then(function() {
              console.log("Document successfully updated!");
              res(true);
            })
            .catch(function(error) {
              console.error("Error updating document: ", error);
              rej(error);
            });
        });
      });
    },

    /*TRACK*/
    getListTracks({ commit }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let listingsTracksRef = db.collection("listings/tracks_guide/items");
        let tracks = [];

        listingsTracksRef
          .where("status", "==", "active")
          .get()
          .then(function(querySnapshot) {
            querySnapshot.forEach(function(doc) {
              // doc.data() is never undefined for query doc snapshots
              console.log("tracks=>", doc.data());
              tracks.push(doc.data());
            });
            commit("SET_LIST_TRACKS", tracks);
            res(tracks);
          })
          .catch(function(error) {
            rej(error);
            console.log("Error getting documents: ", error);
          });
      });
    },
    getTracksByBloggerId({ commit }, bloggerId) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let listingsBlogsRef = db.collection("listings/blogs/items");
        let blogs = [];

        listingsBlogsRef
          .where("status", "==", "active")
          .where("blogger.bloggerId", "==", bloggerId)
          .get()
          .then(function(querySnapshot) {
            querySnapshot.forEach(function(doc) {
              // doc.data() is never undefined for query doc snapshots
              blogs.push(doc.data());
            });
            commit("SET_LIST_BLOGS", blogs);
            res(blogs);
          })
          .catch(function(error) {
            rej(error);
            console.log("Error getting documents: ", error);
          });
      });
    },
    getTrackByTitle({ commit }, trackTitle) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let listingsTrackRef = db.collection("listings/tracks_guide/items");
        let track = {};
        listingsTrackRef
          .get()
          .then(function(querySnapshot) {
            querySnapshot.forEach(function(doc) {
              if (doc.data().slug == trackTitle) {
                track = doc.data();
              }
            });
            res(track);
          })
          .catch(function(error) {
            rej(error);
            console.log("Error getting document: ", error);
          });
      });
    },
    getTrackById({ commit }, blogId) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let listingsBlogRef = db.collection("listings/blogs/items");
        let blog = {};
        listingsBlogRef
          .where("id", "==", blogId)
          .get()
          .then(function(querySnapshot) {
            blog = querySnapshot.docs[0].data();
            res(blog);
          })
          .catch(function(error) {
            rej(error);
            console.log("Error getting document: ", error);
          });
      });
    },
    submitActivationTrack({ commit, state }, { track, owner }) {
      console.log("info", track);
      let url = "";
      if (track.imgURL) {
        url = track.imgURL;
      }
      return new Promise((res, rej) => {
        let trackType = "guide";
        const db = firebase.firestore();
        let listingTrackRef = db
          .collection(`listings/tracks_${trackType}/items`)
          .doc(track.id);
        return listingTrackRef
          .set({
            _created_at: track._created_at,
            _submitted_at: new Date(),
            id: track.id,
            docURL: track.docURL,
            status: "submitted",
            doc: {
              title: track.title,
              detail: track.detail,
              spheres: track.spheres,
              seo: track.seo,
              tools: track.tools,
              guides: track.guides,
              connections: track.connections,
              imgURL: url,
              engine: track.engines,
              weeks: track.weeks,
              price: track.price,
              roles: track.roles,
              categories: track.categories,
              languages: track.languages,
              age: track.age,
              leaningStyle: track.leaningStyle,
              copyright: track.copyright
            },
            owner: owner
          })
          .then(function() {
            console.log("Activation Track Successfully submitted!");
            res(true);
          })
          .catch(function(error) {
            console.error("Error submitting Activation Track", error);
            rej(error);
          });
      });
    },
    getListActivationTrack({ commit, state }, id) {
      return new Promise((res, rej) => {
        let trackType = "guide";
        const db = firebase.firestore();
        let listingTrackRef = db.doc(
          `listings/tracks_${trackType}/items/${id}`
        );
        return listingTrackRef
          .get()
          .then(doc => {
            res(doc.data());
          })
          .catch(function(error) {
            console.log("Error getting document: ", error);
            rej(error);
          });
      });
    },
    /*SESSIONS*/
    //@todo- can save versions
    submitSession({ commit, state }, { session, createdUpdatedBy}) {
      let url = "";
      if (session.imgURL) {
        url = session.imgURL;
      }
      return new Promise((res, rej) => {
        debugger;
        const db = firebase.firestore();
        const status="submitted";

        let listingSessionRef = db
            .collection(`listings/sessions/items`)
            .doc(session.id);

        return listingSessionRef
            .get()
            .then(doc => {
              if (doc.exists) {
                let data = doc.data()
                let prevVersion = data.doc_stage;
                listingSessionRef.update({
                  _updated_by : createdUpdatedBy,
                  _updated_at: new Date(),
                  _submitted_at: new Date(),
                  status_stage: status,
                  doc_stage: { ...session }
                }).then(()=>{
                  res({
                        isSubmitted: true,
                        prevVersion: prevVersion
                      },
                  );
                }).catch((error)=> {
                  console.error(
                      "Error submitting Session",
                      error
                  );
                  rej(error);
                });
              } else {
                 listingSessionRef
                    .set({
                      _created_at: session._created_at,
                      _submitted_at: new Date(),
                      status: status,
                      id: session.id,
                      doc_stage: { ...session },
                      _created_by: createdUpdatedBy
                    })
                    .then(function() {
                      console.log("Session Successfully submitted!");
                      res(true);
                    })
                    .catch((error)=> {
                      console.error(
                          "Error submitting Session",
                          error
                      );
                      rej(error);
                    });
              }
            })
            .catch(err => {
              console.log("error in saving list guide sessions:", err);
            });
      });
    },
    getListSessionById({ commit }, sessionId) {
      return new Promise((res, rej) => {
        //check to see if publishing already exists before fetching again

        const db = firebase.firestore();
        let listingSessionsRef = db.collection(`listings/sessions/items`);
        let sessions = [];

        listingSessionsRef
            .where("status", "==", "active")
            .where("id", "==", sessionId)
            .get()
            .then(function(querySnapshot) {
              querySnapshot.forEach(function(doc) {
                // doc.data() is never undefined for query doc snapshots
                sessions.push(doc.data());
              });
              commit("SET_LIST_SESSIONS", sessions); //reconcile certain ids
              res(sessions);
            })
            .catch(function(error) {
              rej(error);
              console.log("Error getting documents: ", error);
            });
      });
    },
    getListSessions({ commit }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let listingSessionsRef = db.collection(`listings/sessions/items`);
        let sessions = [];

        listingSessionsRef
            .where("status_publish", "==", "active")
            .get()
            .then(function(querySnapshot) {
              querySnapshot.forEach(function(doc) {
                // doc.data() is never undefined for query doc snapshots
                sessions.push(doc.data());
              });
              commit("SET_LIST_SESSIONS", sessions);
              res(sessions);
            })
            .catch(function(error) {
              rej(error);
              console.log("Error getting sessions documents: ", error);
            });
      });
    },

    ///
    getSessionsByBloggerId({ commit }, bloggerId) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let listingsBlogsRef = db.collection("listings/blogs/items");
        let blogs = [];

        listingsBlogsRef
            .where("status", "==", "active")
            .where("blogger.bloggerId", "==", bloggerId)
            .get()
            .then(function(querySnapshot) {
              querySnapshot.forEach(function(doc) {
                // doc.data() is never undefined for query doc snapshots
                blogs.push(doc.data());
              });
              commit("SET_LIST_BLOGS", blogs);
              res(blogs);
            })
            .catch(function(error) {
              rej(error);
              console.log("Error getting documents: ", error);
            });
      });
    },
    getSessionByTitle({ commit }, cornerTitle) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let listingsSessionsRef = db.collection("listings/sessions/items");
        let session = {};

        listingsSessionsRef
            .get()
            .then(function(querySnapshot) {
              querySnapshot.forEach(function(doc) {
                if (doc.data().slug == cornerTitle) {
                  session = doc.data();
                }
              });
              res(session);
            })
            .catch(function(error) {
              rej(error);
              console.log("Error getting session document: ", error);
            });
      });
    },
    getSessionById({ commit }, blogId) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let listingsBlogRef = db.collection("listings/blogs/items");
        let blog = {};
        listingsBlogRef
            .where("id", "==", blogId)
            .get()
            .then(function(querySnapshot) {
              blog = querySnapshot.docs[0].data();
              res(blog);
            })
            .catch(function(error) {
              rej(error);
              console.log("Error getting document: ", error);
            });
      });
    },
    getListActivationSession({ commit, state }, id) {
      return new Promise((res, rej) => {
        let trackType = "guide";
        const db = firebase.firestore();
        let listingTrackRef = db.doc(
            `listings/tracks_${trackType}/items/${id}`
        );
        return listingTrackRef
            .get()
            .then(doc => {
              res(doc.data());
            })
            .catch(function(error) {
              console.log("Error getting document: ", error);
              rej(error);
            });
      });
    },
    /*PUBLISHING- MyApp */
    submitPublishing({ commit, state }, { publishing, owner, publishingType = "author" }) {
      let url = "";
      if (publishing.imgURL) {
        url = publishing.imgURL;
      }
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let listingPublishingRef = db
          .collection(`listings/publishings/items`)
          .doc(publishing.id);
        return listingPublishingRef
          .get()
          .then(doc => {
            if (doc.exists) {
              return listingPublishingRef.update({
                _updated_at: new Date(),
                _submitted_at: new Date(),
                status: "submitted",
                doc_stage: { ...publishing }
              });
            } else {
              return listingPublishingRef
                .set({
                  _created_at: publishing._created_at,
                  _submitted_at: new Date(),
                  status: "submitted",
                  type: publishingType,
                  id: publishing.id,
                  doc_stage: { ...publishing },
                  owner: owner
                })
                .then(function() {
                  console.log("Publishing Successfully submitted!");
                  res(true);
                })
                .catch(function(error) {
                  console.error(
                    "Error submitting Activation Publishing",
                    error
                  );
                  rej(error);
                });
            }
          })
          .catch(err => {
            console.log("error in saving list guide sessions:", err);
          });
      });
    },
    getListPublishingById({ commit }, publishingId) {
      return new Promise((res, rej) => {
        //check to see if publishing already exists before fetching again

        const db = firebase.firestore();
        let listingPublishingRef = db.collection(`listings/publishings/items`);
        let publishings = [];

        listingPublishingRef
          .where("status", "==", "active")
          .where("id", "==", publishingId)
          .get()
          .then(function(querySnapshot) {
            querySnapshot.forEach(function(doc) {
              // doc.data() is never undefined for query doc snapshots
              publishings.push(doc.data());
            });
            commit("SET_LIST_PUBLISHINGS", publishings); //reconcile certain ids
            res(publishings);
          })
          .catch(function(error) {
            rej(error);
            console.log("Error getting documents: ", error);
          });
      });
    },
    getFaveBySlug({ commit }, {slug}) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let favesRef = db.collection("_faves/info/forms");

        favesRef
            .where("slug", "==", slug)
            .get()
            .then((querySnapshot) => {
              let docs = querySnapshot.docs;
              if(docs && Array.isArray(docs) && docs.length > 0) {
                res(docs[0].data());
              } else {
                res(null);
              }
            })
            .catch(function(error) {
              rej(error);
              console.log("Error getting document: ", error);
            });
      });
    },
    getListPublishings({ commit }) {
      return new Promise((res, rej) => {
        let publishingType = "author";
        const db = firebase.firestore();
        let listingPublishingRef = db.collection(`listings/publishings/items`);
        let publishings = [];

        listingPublishingRef
          .where("status", "==", "active")
          .get()
          .then(function(querySnapshot) {
            querySnapshot.forEach(function(doc) {
              // doc.data() is never undefined for query doc snapshots
              publishings.push(doc.data());
            });
            commit("SET_LIST_PUBLISHINGS", publishings);
            res(publishings);
          })
          .catch(function(error) {
            rej(error);
            console.log("Error getting documents: ", error);
          });
      });
    },
    getPublishingsByBloggerId({ commit }, bloggerId) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let listingsBlogsRef = db.collection("listings/blogs/items");
        let blogs = [];

        listingsBlogsRef
          .where("status", "==", "active")
          .where("blogger.bloggerId", "==", bloggerId)
          .get()
          .then(function(querySnapshot) {
            querySnapshot.forEach(function(doc) {
              // doc.data() is never undefined for query doc snapshots
              blogs.push(doc.data());
            });
            commit("SET_LIST_BLOGS", blogs);
            res(blogs);
          })
          .catch(function(error) {
            rej(error);
            console.log("Error getting documents: ", error);
          });
      });
    },
    getPublishingById({ commit }, blogId) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let listingsBlogRef = db.collection("listings/blogs/items");
        let blog = {};
        listingsBlogRef
          .where("id", "==", blogId)
          .get()
          .then(function(querySnapshot) {
            blog = querySnapshot.docs[0].data();
            res(blog);
          })
          .catch(function(error) {
            rej(error);
            console.log("Error getting document: ", error);
          });
      });
    },
    getListActivationPublishing({ commit, state }, id) {
      return new Promise((res, rej) => {
        let trackType = "guide";
        const db = firebase.firestore();
        let listingTrackRef = db.doc(
          `listings/tracks_${trackType}/items/${id}`
        );
        return listingTrackRef
          .get()
          .then(doc => {
            res(doc.data());
          })
          .catch(function(error) {
            console.log("Error getting document: ", error);
            rej(error);
          });
      });
    },
    getPublishingByMyAppName({ commit }, {myAppName}) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let listingsPublishingRef = db.collection("listings/publishings/items");
        let publishing = {};
        listingsPublishingRef
            .where("slug", "==", myAppName)
            .get()
            .then(function(querySnapshot) {
              querySnapshot.forEach((doc) => {
                if (doc.data().slug == myAppName) {
                  publishing = doc.data();
                }
              });
              res(publishing);
            })
            .catch(function(error) {
              rej(error);
              console.log("Error getting document: ", error);
            });
      });
    },
    getPublishedMyAppDisplayByNameAndHeartBeat({ commit }, {myAppName, heartbeat}) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let listingsPublishingRef = db.collection("listings/publishings/items");
        let usersRef = db.collection("users");
        let publishing = {};
        const resourceId = "hIrdo4zaZ2mhwiCR9JPy"//"7tI4hj9lEcUQ7twIFaCh"; //'UsERdhWc6Q8lCu4Uhy9w'; //@Todo-temp

        listingsPublishingRef
            .where("slug", "==", myAppName)
            .get()
            .then((querySnapshot) =>{
              querySnapshot.forEach((doc) => {
                if (doc.data().slug == myAppName) {
                  publishing = doc.data();
                  //Get the resourceId
                }
              });

              usersRef
                  .where("heartbeat.profileName", "==", heartbeat)
                  .get()
                  .then((querySnapshot) =>{
                    let userId = null;

                    if (querySnapshot.docs.length > 0) {
                      userId = querySnapshot.docs[0].id;

                      const displayDataRef = db.doc(`users/${userId}/lists/__apps/data/${resourceId}`);

                      displayDataRef
                          .get().then((doc) => {
                            if (doc.exists) {
                              res(
                                  {
                                    resourceId: resourceId,
                                    heartbeatData: doc.data()
                                  }
                              );
                            } else {
                              res({})
                            }
                          }
                      ).catch((err) => {
                        rej(err);
                      });
                    }
                  });
            })
            .catch((error)=>{
              rej(error);
            });
      })
    },
    getPublishedMyAppSettingsByNameAndHeartBeat({ commit }, {myAppName, heartbeat}) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let listingsPublishingRef = db.collection("listings/publishings/items");
        let usersRef = db.collection("users");
        let publishing = {};
        const resourceId = "hIrdo4zaZ2mhwiCR9JPy"//"7tI4hj9lEcUQ7twIFaCh"; //'UsERdhWc6Q8lCu4Uhy9w'; //@Todo-temp

        listingsPublishingRef
            .where("slug", "==", myAppName)
            .get()
            .then((querySnapshot) =>{
              querySnapshot.forEach((doc) => {
                if (doc.data().slug == myAppName) {
                  publishing = doc.data();
                  //Get the resourceId
                }
              });

              usersRef
                  .where("heartbeat.profileName", "==", heartbeat)
                  .get()
                  .then((querySnapshot) =>{
                    let userId = null;

                    if (querySnapshot.docs.length > 0) {
                      userId = querySnapshot.docs[0].id;

                      const displayDataRef = db.doc(`users/${userId}/lists/__apps/settings/${resourceId}`);

                      displayDataRef
                          .get().then((doc) => {
                            if (doc.exists) {
                              res(
                                  {
                                    resourceId: resourceId,
                                    heartbeatSettings: doc.data()
                                  }
                              );
                            } else {
                              res({})
                            }
                          }
                      ).catch((err) => {
                        rej(err);
                      });
                    }
                  });
            })
            .catch((error)=>{
              rej(error);
            });
      })
    },
    /* PRODUCTS  */
    getListProducts({ commit }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let listingsProductsRef = db.collection(
          "listings/products_guide/items"
        );
        let products = [];

        listingsProductsRef
          .where("status", "==", "active")
          .get()
          .then(function(querySnapshot) {
            querySnapshot.forEach(function(doc) {
              // doc.data() is never undefined for query doc snapshots
              console.log("products=>", doc.data());
              products.push(doc.data());
            });
            commit("SET_LIST_PRODUCTS", products);
            res(products);
          })
          .catch(function(error) {
            rej(error);
            console.log("Error getting documents: ", error);
          });
      });
    },
    getProductsByBloggerId({ commit }, bloggerId) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let listingsBlogsRef = db.collection("listings/blogs/items");
        let blogs = [];

        listingsBlogsRef
          .where("status", "==", "active")
          .where("blogger.bloggerId", "==", bloggerId)
          .get()
          .then(function(querySnapshot) {
            querySnapshot.forEach(function(doc) {
              // doc.data() is never undefined for query doc snapshots
              blogs.push(doc.data());
            });
            commit("SET_LIST_BLOGS", blogs);
            res(blogs);
          })
          .catch(function(error) {
            rej(error);
            console.log("Error getting documents: ", error);
          });
      });
    },
    getProductByTitle({ commit }, productTitle) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let listingsProductRef = db.collection("listings/products_guide/items");
        let product = {};
        listingsProductRef
          .get()
          .then(function(querySnapshot) {
            querySnapshot.forEach(function(doc) {
              if (doc.data().slug == productTitle) {
                product = doc.data();
              }
            });
            res(product);
          })
          .catch(function(error) {
            rej(error);
            console.log("Error getting document: ", error);
          });
      });
    },
    getProductById({ commit }, blogId) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let listingsBlogRef = db.collection("listings/blogs/items");
        let blog = {};
        listingsBlogRef
          .where("id", "==", blogId)
          .get()
          .then(function(querySnapshot) {
            blog = querySnapshot.docs[0].data();
            res(blog);
          })
          .catch(function(error) {
            rej(error);
            console.log("Error getting document: ", error);
          });
      });
    },

    /*CHARITIES*/
    getListCharities({ commit, state }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let charitiesRef = db.collection("listings").doc("charities");
        return charitiesRef
          .get()
          .then(doc => {
            res(doc.data().list);
          })
          .catch(function(error) {
            // The document probably doesn't exist.
            console.error("Error updating Blogger Info: ", error);
            rej(error);
          });
      });
    },
    /* COMPANY */
    getCompanyById({ commit, state }, profile) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let guide = null;
        let listingGuideRef = db
          .collection("listings/bloggers/items")
          .doc(profile.userId);
        listingGuideRef
          .get()
          .then(function(doc) {
            if (doc.exists) {
              guide = doc.data();
            } else {
              // doc.data() will be undefined in this case
              console.log("No such document!");
            }
            res(guide);
          })
          .catch(function(error) {
            console.log("Error getting document:", error);
            rej(error);
          });
      });
    },
    checkProfileName({ commit, state }, { classType, profileName }) {
      let profileNameTrim = profileName.trim().toLowerCase();
      return new Promise((res, rej) => {
        let nameExists = false;
        const db = firebase.firestore();
        let companies = db
          .collection("listings")
          .doc(classType)
          .collection("items")
          .where("profile.profileName", "==", profileNameTrim);
        return companies
          .get()
          .then(querySnapshot => {
            if (querySnapshot.docs.length > 0) {
              res("already taken");
            } else {
              res("accepted");
            }
          })
          .catch(error => {
            console.log(error);
            rej(error);
          });
      });
    },
    activateCompany({ commit, state }, profile) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let listingBlogRef = db
          .collection("listings/companies/items")
          .doc(profile.userId);
        //@TODO Will be multiple at some point
        let companies_profile = profile._dashboards.companies;

        // Set the "capital" field of the city 'DC'
        return listingBlogRef
          .update({
            _updated_at: new Date(),
            profile: companies_profile,
            user: {
              email: profile.email,
              userId: profile.userId,
              firstname: profile.firstname || "",
              imgURL: profile.imgURL || "",
              lastname: profile.lastname || "",
              phoneNumber: profile.phoneNumber || ""
            }
          })
          .then(function() {
            console.log("Blogger Info Successfully updated!");
            res(true);
          })
          .catch(function(error) {
            // The document probably doesn't exist.
            console.error("Error updating Guide Info: ", error);
            rej(error);
          });
      });
    }
  },
  mutations: {
    SET_LIST_TOOLS(state, listTools) {
      if (listTools) {
        state.listTools = listTools;
      } else {
        state.listTools = [];
      }
    },
    SET_LIST_CONNECTIONS(state, connections) {
      if (connections) {
        state.listConnections = connections;
      } else {
        state.listConnections = [];
      }
    },
    SET_LIST_GUIDES(state, listGuides) {
      if (listGuides) {
        state.listGuides = listGuides;
      } else {
        state.listGuides = [];
      }
    },
    SET_GUIDE_CHAT_ID(state, id) {
      state.guideChatId = id;
    },
    SET_GUIDE_CHAT(state, chat) {
      state.guideChat = chat;
    },
    SET_LIST_BLOGS(state, items) {
      if (items) {
        state.blogs = items;
      } else {
        state.blogs = [];
      }
    },
    SET_LIST_BLOGGERS(state, listBloggers) {
      if (listBloggers) {
        state.listBloggers = listBloggers;
      } else {
        state.listBloggers = [];
      }
    },
    SET_LIST_TRACKS(state, items) {
      if (items) {
        state.tracks = items;
      } else {
        state.tracks = [];
      }
    },
    SET_LIST_PUBLISHINGS(state, items) {
      if (items) {
        state.publishings = items;
      } else {
        state.publishings = [];
      }
    },
    SET_LIST_SESSIONS(state, items) {
      if (items) {
        state.sessions = items;
      } else {
        state.sessions = [];
      }
    },
    SET_LIST_PRODUCTS(state, items) {
      if (items) {
        state.products = items;
      } else {
        state.products = [];
      }
    },
    SET_BLOGGER_BLOGS(state, items) {
      if (items) {
        state.bloggerBlogs = items;
      } else {
        state.bloggerBlogs = [];
      }
    }
  }
};
